import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import CustomerViewTable from "./Componates/CustomersFullView";
import { GetById } from "adminApi/CustomersApi/Customers";

const CustomerView = () => {
  const { id } = useParams();
  const [customer, setCustomer] = useState({});
  const hasFetched = useRef(false);
  useEffect(() => {
    if (!id) return;

    if (hasFetched.current) return;
    hasFetched.current = true;

    const fetchData = async () => {
      try {
        const response = await GetById(id);
        if (response?.data?.success || response?.data?.status === 200) {
          setCustomer(response.data.data);
        } else {
          setCustomer({});
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        setCustomer({});
      }
    };

    fetchData();
  }, [id]);

  return (
    <PageBody
      card
      headerchildren={<HeadingOne>Customers View</HeadingOne>}
    >
      
        <CustomerViewTable customer={customer} />

    </PageBody>
  );
};

export default CustomerView;
